
class Modal extends HTMLElement {
  constructor() {
    super();
    this.opener = this.querySelector(".modal_open")
    this.closer = this.querySelector(".modal_closer")
    this.overlay = document.querySelector(".quickadd-modal-overlay") || document.querySelector(".modal-overlay")
    this.modal = this.querySelector('.modal_content')
    this.overlay.addEventListener(
      'click', (event) => {
        this.modal.style.display = "none"
        this.overlay.style.display = "none"
      }
    );
    if (this.closer != null) {
      this.closer.addEventListener(
        'click', (event) => {
          this.modal.style.display = "none"
          this.overlay.style.display = "none"
        }
      );
    }
    if (this.opener != null) {
      this.opener.addEventListener(
        'click', (event) => {
          this.modal.style.display = "block"
          this.overlay.style.display = "block"
        }
      );
    }
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.modal.style.display = "none";
    });
  }

}
customElements.define('modal-simple', Modal);
